import i18n from "../../../../utils/ChrI18n";
import React from 'react';

export const closeActionRenderer = (props = {}) => {
  return (
    <button
      key="close"
      className={ `btn btn-white ${props.closeActionClassName}` }
      onClick={ props.hideModal }>
      { props.closeActionText || i18n.t("display_string.Close") }
    </button>
  );
};